import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils/cn';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  leadingIcon?: ReactNode;
  trailingAdornment?: ReactNode;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { leadingIcon, trailingAdornment, invalid, className, ...props },
  ref,
) {
  return (
    <div
      className={cn(
        'group flex h-9 items-center gap-2 rounded-md border border-line bg-canvas px-3 text-sm',
        'transition-colors focus-within:border-ink focus-within:bg-board',
        invalid && 'border-red-500/40 focus-within:border-red-600',
        className,
      )}
    >
      {leadingIcon ? (
        <span className="text-ink-faint transition-colors group-focus-within:text-ink">
          {leadingIcon}
        </span>
      ) : null}
      <input
        ref={ref}
        className="flex-1 bg-transparent text-ink placeholder:text-ink-faint focus:outline-none"
        {...props}
      />
      {trailingAdornment ? (
        <span className="flex items-center gap-1 text-xs text-ink-faint">{trailingAdornment}</span>
      ) : null}
    </div>
  );
});
